<template>
  <div class="__wrapper">
    <div class="__head" :style="{
      'background-image': user.cover_picture
        ? 'url(' + $fullUrl('images/covers/' + user.cover_picture) + ')'
        : false,
    }">
      <div class="person-card">
        <img v-if="user.profile" :src="$fullUrl('images/profiles/' + user.profile)" />
        <img v-else src="@/assets/avatar.png" alt />
        <div class="info-text">
          <h2>{{ user.names | validate }}</h2>
          <span>{{ user.job | validate }}</span>
        </div>
      </div>
    </div>
    <div class="__body">
      <div class="__container">
        <div class="__qualifications__wrapper __card">
          <div class="__content-body __bg-grey">
            <div class="__menus-tab">
              <span :class="{ activetablink: tab5.isTab1 }" @click="showSubTab('isTab1')">Personal information</span>
              <span :class="{ activetablink: tab5.isTab2 }" @click="showSubTab('isTab2')">Security information</span>
              <span :class="{ activetablink: tab5.isTab3 }" @click="showSubTab('isTab3')">Terms & Conditions</span>
            </div>
            <div class="__tabs-body">
              <div class="__tabs__content" v-show="tab5.isTab1">
                <div class="tabs__content-wrapper">
                  <h2>Personal information</h2>
                  <div class="__form">
                    <div class="form-group">
                      <div class="__box">
                        <span>First name</span>
                        <input type="text" v-model="user_profile.first_name" />
                      </div>
                      <div style="width: 5px"></div>
                      <div class="__box">
                        <span>Last name</span>
                        <input type="text" v-model="user_profile.last_name" />
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="__box">
                        <span>School E-mail Address</span>
                        <input type="text" v-model="user_profile.email" />
                      </div>
                      <div style="width: 5px"></div>
                      <div class="__box">
                        <span>Personal E-mail Address</span>
                        <input type="text" v-model="user_profile.organization_email" />
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="__box">
                        <span>Location</span>
                        <map-helper v-model="user_profile.address"></map-helper>
                      </div>
                      <div style="width: 5px"></div>

                      <div class="__box">
                        <span>Telephone</span>
                        <input type="text" v-model="user_profile.phone" />
                      </div>
                      <div class="__box" v-if="false">
                        <span>When are you available?</span>
                        <div class="range-date">
                          <div class="check-label">
                            <label for="curr">Currently unavailable</label>
                            <input type="checkbox" v-model="user_profile.unavailable" name="curr" id="curr" />
                          </div>
                          <datepicker :monday-first="true" placeholder="From" :disabled-dates="{ to: new Date() }"
                            :disabled="user_profile.unavailable" v-model="user_profile.available_from"
                            :clear-button="false" input-class="date-field-input" wrapper-class="date-field">
                          </datepicker>
                          <datepicker :monday-first="true" placeholder="To" :disabled="user_profile.unavailable"
                            :clear-button="false" :disabled-dates="{
                              to: new Date(user_profile.available_from),
                            }" v-model="user_profile.available_until" input-class="date-field-input"
                            wrapper-class="date-field"></datepicker>
                        </div>
                      </div>
                    </div>
                    <div class="form-group"></div>
                    <div class="__box">
                      <span style="margin-bottom: 10px; margin-top: 15px">Description</span>
                      <html-editor v-model="user_profile.description" id="edit-descr" />
                    </div>

                    <div class="form-group"></div>
                    <div class="__box">
                      <span style="margin-bottom: 10px; margin-top: 15px">Linkedin Profile link</span>
                      <input type="text" v-model="user_profile.linkedin_link" />
                    </div>

                    <div class="__box">
                      <div class="upload-widget" style="margin-top: 10px">
                        <div class="image-upload-widget">
                          <span style="margin-bottom: 10px">Profile picture</span>
                          <div class="profile-picture">
                            <upload :crop="true" :value="{
                              url: $fullUrl('images/profiles/'),
                              file_name: user_profile.profile_picture,
                            }" @onFileSelected="setProfileLogo" />
                          </div>
                        </div>
                        <div class="image-upload-widget">
                          <span style="margin-bottom: 10px">Cover picture</span>
                          <div class="cover-upload-widget">
                            <div class="cover-upload">
                              <upload :crop="true" :ration="10 / 1" :value="{
                                url: $fullUrl('images/covers/'),
                                file_name: user_profile.cover_picture,
                              }" @onFileSelected="setCoverLogo" />
                            </div>
                            <div class="default-cover-image">
                              <div class="cover-image-item" :class="{
                                active:
                                  user_profile.cover_picture ==
                                  index - 1 + '.png',
                              }" v-for="index in 2" :key="index" @click="setCoverImage(index - 1 + '.png')">
                                <img :src="$fullUrl(
                                  'images/covers/' + (index - 1) + '.png'
                                )
                                  " />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="btns">
                      <button class="__btn" @click="saveChanges">Save</button>
                      <button class="__cancel" @click="cancel">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="__tabs__content" v-show="tab5.isTab2">

                <div class="tabs__content-wrapper">

                  <div v-if="user.provider == 'consultified'" class="setting-card">
                    <h2>Change password</h2>
                    <div class="__form">
                      <div class="form-group">
                        <div class="__box" style="position: relative">
                          <span>Current Password</span>
                          <input type="password" v-model="oldPassword" />
                          <!-- <router-link to="/forgot-password" class="link">
                          <span>Forgot Password?</span>
                        </router-link> -->
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="__box">
                          <span>New Password</span>
                          <input type="password" v-model="newPassword" />
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="__box">
                          <span>Confirm Password</span>
                          <input type="password" v-model="newPassword2" />
                        </div>
                      </div>
                      <div class="btns">
                        <button class="__btn" @click="changePassword">
                          Save
                        </button>
                        <button class="__cancel" @click="cancel">Cancel</button>
                      </div>
                    </div>
                  </div>

                  <div class="setting-card">
                    <h2>Switch Account</h2>
                    <div class="switch-account-options">
                      <button class="switch-btn" v-if="user.provider != 'google'" @click="switchAccount('google')">
                        <img src="@/assets/icons/google.svg" width="20" alt />
                        <span>Switch to Google</span>
                      </button>
                      <button class="switch-btn" v-if="user.provider != 'microsoft'"
                        @click="switchAccount('microsoft')">
                        <img src="@/assets/icons/microsoft.svg" width="20" alt />
                        <span>Switch to Microsoft</span>
                      </button>
                    </div>
                  </div>

                  <div class="setting-card" v-if="user.provider != 'consultified'">
                    <h2>Switch Back to Normal Account</h2>
                    <div class="switch-account-options">
                      <button class="switch-btn" @click="switchAccount('normal')">
                        <span>Switch Account</span>
                      </button>
                    </div>
                  </div>

                  <div class="setting-card">
                    <h2>Delete Account</h2>
                    <button class="delete-btn" @click="showConfirm = true">
                      Delete
                    </button>
                  </div>
                </div>
              </div>
              <div class="__tabs__content" v-show="tab5.isTab3">
                <div class="tabs__content-wrapper">
                  <terms-widget />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="floater">
        <chat></chat>
      </div>
    </div>


    <template>
      <v-layout justify-center>
        <v-dialog v-model="showConfirm" persistent max-width="400">
          <v-card color="#FFFFFF" style="border-radius: 5px">
            <v-layout>
              <div class="cardd__boddy">
                <div class="__header">
                  <label>Warning</label>
                </div>
                <div class="contents">
                  <p>Are you sure you want to delete your Account for good?</p>
                </div>
                <div class="footer">
                  <button @click="(e) => {
                    deleteAccount();
                    showConfirm = false;
                  }
                    ">
                    Delete
                  </button>
                  <button @click="(e) => {
                    showConfirm = false;
                  }
                    " class="cancel">
                    Cancel
                  </button>
                </div>
              </div>
            </v-layout>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <switch-normal-account-modal v-if="showSwitchNormalAccountModal" @success="handleSwitchNormalAccountSuccess"
      @close="showSwitchNormalAccountModal = false" />

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import Datepicker from "vuejs-datepicker";
import Chat from "@/components/Chat/Chat";
import upload from "@/components/Partials/Uploader.vue";
import axios from "axios";
import TermsWidget from "@/components/TermsWidget.vue";
import SwitchNormalAccountModal from "./modals/switch-normal-account-modal.vue";
export default {
  name: "Settings",
  selectedProjected: {},
  selectedEmploymented: {},
  components: {
    Datepicker,
    Chat,
    upload,
    TermsWidget,
    SwitchNormalAccountModal,
  },
  computed: {
    ...mapGetters([
      "getMeProfile",
      "getSearchedPeople",
      "getLoader",
      "getCountries",
      "getCities",
      "getCompanies",
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    user() {
      let job = "";
      let country = "";
      let city = "";
      let description = "";
      if (this.getMeProfile.employment.length > 0)
        job = this.getMeProfile.employment[0].company.name;
      if (this.getMeProfile.profile.location) {
        if (this.getMeProfile.profile.location.country_id) {
          country = this.getMeProfile.profile.location.country.name;
          this.$store.dispatch("GET_CITIES", {
            country: this.getMeProfile.profile.location.country_id,
          });
        }
        if (this.getMeProfile.profile.location.city_id)
          city = this.getMeProfile.profile.location.city.name;
      }
      if (this.getMeProfile.profile.description) {
        description = this.getMeProfile.profile.description;
      } else {
        this.getMeProfile.profile.description = "";
      }
      if (
        this.getMeProfile.profile.available_from == "0000-00-00" ||
        this.getMeProfile.profile.available_from == ""
      ) {
        this.unavailable = true;
      } else {
        this.unavailable = false;
      }
      const newData = {
        profile: this.getMeProfile.user.profile_picture,
        names:
          this.getMeProfile.user.first_name +
          " " +
          this.getMeProfile.user.last_name,
        email: this.getMeProfile.user.email,
        phone: this.getMeProfile.profile.phone,
        provider: this.getMeProfile.user.provider,
        city: city,
        country: country,
        location: country + (city === "" ? "" : "," + city),
        available: "Available From",
        available_from: this.getMeProfile.profile.available_from,
        is_available: this.getMeProfile.profile.available_from ? true : false,
        job: job,
        profile_picture: this.getMeProfile.user.profile_picture,
        cover_picture: this.getMeProfile.profile.cover_photo,
        description: description,
      };
      console.log(newData);
      return newData;
    },
    names() {
      return (
        this.getMeProfile.user.first_name +
        " " +
        this.getMeProfile.user.last_name
      );
    },
    userId() {
      return this.getMeProfile.user.id;
    },
    id() {
      return this.getMeProfile.user.id;
    },
    location() {
      if (this.getMeProfile.profile.location)
        return {
          country: this.getMeProfile.profile.location.country_id,
          city: this.getMeProfile.profile.location.city_id,
          address: this.getMeProfile.profile.location.address,
        };
      else
        return {
          country: 0,
          city: 0,
          address: "",
        };
    },
  },
  data() {
    return {
      selected_profile: null,
      showConfirm: false,
      tab5: {
        isTab1: true,
        isTab2: false,
        isTab3: false,
      },
      oldPassword: "",
      newPassword: "",
      newPassword2: "",
      user_profile: {
        first_name: "",
        last_name: "",
        email: "",
        organization_email: "",
        phone: "",
        country: 0,
        city: 0,
        unavailable: false,
        available_from: "",
        available_until: "",
        description: "",
        address: "",
        selected_profile: null,
        profile_picture: "",
        selected_cover: null,
        cover_picture: "",
        profile_picture_set: true,
        cover_picture_set: true,
        linkedin_link: "",
      },
      showSwitchNormalAccountModal: false,
    };
  },
  mounted() {
    this.initiaData();
  },
  methods: {
    initiaData() {
      let vm = this;
      this.$store.dispatch("GET_COUNTRIES");
      this.$store.dispatch("GET_ME_PROFILE_DATA").then((response) => {
        let data = response.data;
        vm.user_profile.first_name = data.user.first_name;
        vm.user_profile.last_name = data.user.last_name;
        vm.user_profile.email = data.user.email;
        vm.user_profile.organization_email = data.user.organization_email;
        if (data.profile.phone != "null") {
          vm.user_profile.phone = data.profile.phone;
        }

        vm.user_profile.address = data.profile.address;

        if (
          data.profile.available_from == "0000-00-00" ||
          data.profile.available_from == ""
        ) {
          vm.user_profile.unavailable = true;
        } else {
          vm.user_profile.unavailable = false;
        }
        vm.user_profile.available_from = data.profile.available_from;
        vm.user_profile.available_until = data.profile.available_until;
        if (data.profile.description && data.profile.description !== "null") {
          vm.user_profile.description = data.profile.description;
        }
        vm.user_profile.profile_picture = data.user.profile_picture;
        vm.user_profile.selected_profile = null;
        vm.user_profile.cover_picture = data.user.profile.cover_photo;
        vm.user_profile.linkedin_link = data.user.profile.linkedin_link;
      });
      if (this.$route.params.tab === "terms") {
        this.showSubTab("isTab3");
      }
    },
    handleSwitchNormalAccountSuccess() {
      this.showSwitchNormalAccountModal = false;
      this.initiaData();
    },
    switchAccount(provider) {
      if (provider === 'normal') {
        this.showSwitchNormalAccountModal = true;
      } else {
        this.$store.dispatch("SWITCH_ACCOUNT", { provider: provider, user_id: this.getMeProfile.user.id }).then((response) => {
          window.location.href = response.data.url;
        }).catch(error => {
          this.$notify({
            group: "status",
            text: error.response.data.error,
            type: "warn",
            duration: 3000,
          });
        });
      }
    },
    getLocation(data) {
      let vm = this;
      vm.user_profile.address = data.name;
    },
    setCoverImage(file_name) {
      let vm = this;
      vm.user_profile.cover_picture = file_name;
      vm.user_profile.selected_cover = null;
      vm.user_profile.cover_picture_set = true;
    },
    setCoverLogo(file) {
      let vm = this;
      if (file) {
        vm.user_profile.selected_cover = file;
        vm.user_profile.cover_picture = "";
        vm.user_profile.cover_picture_set = true;
      } else {
        vm.user_profile.cover_picture_set = false;
      }
    },
    setProfileLogo(file) {
      let vm = this;
      if (file) {
        vm.user_profile.selected_profile = file;
        vm.user_profile.profile_picture = "";
        vm.user_profile.profile_picture_set = true;
      } else {
        vm.user_profile.profile_picture_set = false;
      }
    },
    cancel() {
      this.$router.push({ name: "consultant-profile" });
    },
    handleDate(date) {
      if (!date) return null;
      try {
        return new Date(date).toISOString().slice(0, 10);
      } catch (e) {
        return "";
      }
    },
    saveChanges() {
      let vm = this;
      let form_data = new FormData();
      form_data.append("first_name", vm.user_profile.first_name);
      form_data.append("last_name", vm.user_profile.last_name);
      // form_data.append("email", vm.user_profile.email);
      form_data.append(
        "organization_email",
        vm.user_profile.organization_email
      );
      form_data.append("availability", vm.user_profile.availability);
      form_data.append(
        "available_until",
        vm.handleDate(vm.user_profile.available_until)
      );
      form_data.append(
        "available_from",
        vm.handleDate(vm.user_profile.available_from)
      );

      form_data.append("phone", vm.user_profile.phone);
      form_data.append("address", vm.user_profile.address);
      form_data.append("description", vm.user_profile.description);

      if (vm.user_profile.selected_profile) {
        form_data.append(
          "profile_image",
          vm.user_profile.selected_profile,
          vm.user_profile.selected_profile.name
        );
      } else {
        form_data.append("profile_image", null);
      }

      if (vm.user_profile.selected_cover) {
        form_data.append(
          "cover_picture",
          vm.user_profile.selected_cover,
          vm.user_profile.selected_cover.name
        );
      } else {
        if (vm.user_profile.cover_picture) {
          form_data.append("default_cover", vm.user_profile.cover_picture);
        }
      }

      form_data.append(
        "profile_picture_set",
        vm.user_profile.profile_picture_set
      );
      form_data.append("cover_picture_set", vm.user_profile.cover_picture_set);
      form_data.append("linkedin_link", vm.user_profile.linkedin_link);

      this.$store.dispatch("EDIT_PROFILE_INFO", form_data);
    },

    deleteAccount() {
      this.$store.dispatch("DELETE_ACCOUNT");
    },
    changePassword() {
      let vm = this;
      let data = {
        new_password: this.newPassword,
        old_password: this.oldPassword,
      };
      if (this.newPassword2 === this.newPassword)
        this.$store.dispatch("CHANGE_PASSWORD", data).then(response => {

        }).catch(error => {
          vm.$notify({
            group: "status",
            title: "Important message",
            text: error.response.data.error,
            type: "warn",
            duration: 3000,
          });
        });
      else
        this.$store.dispatch("SET_INFO", {
          state: true,
          message: "Your passwords don't match",
          title: "Change Password",
        });
    },

    loadCities(e) {
      this.$store.dispatch("GET_CITIES", { country: e.target.value });
    },

    showSubTab(key) {
      let vm = this;
      Object.keys(this.tab5).forEach(function (key) {
        vm.tab5[key] = false;
      });
      this.tab5[key] = true;
    },
  },
  watch: {
    "user_profile.unavailable"(val) {
      let vm = this;
      if (val) {
        vm.user_profile.available_from = "";
        vm.user_profile.available_until = "";
        vm.getMeProfile.profile.available_from = "";
        vm.getMeProfile.profile.available_until = "";
      }
    },
    unavailable: function (val) {
      if (val) {
        this.getMeProfile.profile.available_from = "";
        this.getMeProfile.profile.available_until = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.__wrapper {
  background: rgba(239, 239, 239, 0.49);
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  flex-direction: column;

  .__head {
    height: 90px;
    position: relative;
    margin-top: 55px;
    background-image: url($assets + "/images/backgrounds/wallpaper.svg");
    background-size: cover;

    .person-card {
      position: absolute;
      left: 50%;
      display: flex;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      align-items: center;

      img {
        width: 40px;
        height: 40px;
        border-radius: 100%;
      }

      .info-text {
        margin-left: 10px;
        display: flex;
        margin-top: 5px;
        flex-direction: column;

        h2 {
          font-size: 16px;
          margin-bottom: 10px;
          font-family: "Nunito", sans-serif;
          font-weight: bolder;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.5;
          letter-spacing: normal;
          color: #fff;
          text-shadow: 1px 1px 0px #000;
        }

        span {
          font-size: 13px;
          margin-bottom: 0;
          font-family: "Nunito", sans-serif;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: normal;
          color: #fff;
          text-shadow: 1px 1px 0px #000;
        }
      }
    }
  }

  .__body {
    height: 100%;
    overflow-y: auto;
    display: flex;
    justify-content: center;

    .__container {
      margin: 0 auto;
      width: 800px;
      padding: 10px;
      position: relative;

      @media (min-width: 300px) and (max-width: 630px) {
        grid-template-columns: 1fr;
        width: 100%;
        padding: 5px;
      }

      .__qualifications__wrapper {
        background: #fff;
        padding: 20px;
        border-radius: 10px;
        width: 100%;

        @media (min-width: 300px) and (max-width: 630px) {
          padding: 5px;
        }

        .__content-body {
          font-weight: normal;
          width: 100%;

          .__menus-tab {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            background: #f5f5f5;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            overflow: hidden;

            span {
              padding: 12px 0;
              cursor: pointer;
              color: #fff;
              font-size: 15px;
              text-align: center;
              background: #cccccc;
              font-family: "Nunito", sans-serif;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.36;
              letter-spacing: normal;

              @media (min-width: 300px) and (max-width: 630px) {
                font-size: 12px;
              }

              /*&:hover{*/
              /*background: #FFF;*/
              /*color: #1BA5A4;*/
              /*font-weight: normal;*/
              /*}*/
            }

            .activetablink {
              background: #f5f5f5;
              color: #1ba5a4;
              border-bottom-left-radius: 5px;
            }
          }

          .__tabs-body {
            position: relative;

            .__tabs__content {
              position: relative;
              top: 0;
              left: 0;

              .tabs__content-wrapper {
                display: flex;
                flex-direction: column;

                .__logo {
                  margin: 20px 0;
                  width: 70px;
                  height: 65px;
                }

                .tmz {
                  margin-top: 10px;
                  /*background: #FFF;*/
                  /*padding: 20px;*/
                }

                padding: 20px 0;

                h2 {
                  font-family: "Nunito", sans-serif;
                  font-size: 13px;
                  font-weight: 900;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 3.77;
                  letter-spacing: normal;
                  text-align: left;
                  color: #000000;
                }

                .__form {
                  span {
                    margin-left: 10px;
                    font-family: "Nunito", sans-serif;
                    font-size: 14px;
                    font-weight: 300;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 0.86;
                    letter-spacing: normal;
                    text-align: left;
                    color: #646262;
                  }

                  .asterix {
                    font-weight: 900;
                    color: #1ba5a4;
                  }

                  h2 {
                    color: #000000;
                    font-size: 15px;
                    margin-bottom: 20px;
                    font-weight: normal;
                  }

                  .form-group {
                    display: flex;
                    justify-content: space-between;

                    @media (min-width: 300px) and (max-width: 630px) {
                      flex-direction: column;
                      width: 100%;
                    }

                    .__box {
                      max-width: 50%;
                      width: 50%;
                      display: flex;
                      flex-direction: column;

                      @media (min-width: 300px) and (max-width: 630px) {
                        width: 100%;
                        max-width: 100%;
                      }

                      span {
                        font-size: 14px;
                        margin-left: 10px;
                        margin-bottom: 10px;
                        color: #646262;
                      }

                      .grouped,
                      input[type="text"],
                      input[type="password"],
                      textarea,
                      select {
                        background: #fff;
                        font-size: 14px;
                        resize: none;
                        display: flex;
                        margin-bottom: 20px;
                        justify-content: space-between;
                        width: 100%;
                        padding: 10px;
                        outline: none;
                        border-radius: 5px;
                        border: 1px solid #ddd;
                        color: #707070;
                        height: 52px;

                        .__date-field {
                          background: #f4f4f4;
                          width: 49%;
                          border-radius: 5px;
                          padding: 7px;
                        }
                      }

                      textarea {
                        resize: none;
                        height: 150px;
                      }

                      .grouped {
                        padding: 4px 10px;
                      }
                    }
                  }

                  .__box {
                    max-width: 100%;
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    .upload-widget {
                      display: grid;
                      grid-template-columns: 240px calc(98% - 240px);
                      grid-column-gap: 20px;

                      @media (min-width: 300px) and (max-width: 630px) {
                        grid-template-columns: 100%;
                      }

                      .image-upload-widget {
                        .profile-picture {
                          background: #fff;
                          width: 100%;
                          display: flex;
                          justify-content: center;
                          height: 283px;
                          border-radius: 5px;
                          padding: 20px;
                        }

                        .cover-upload-widget {
                          background: #fff;
                          border-radius: 5px;
                          display: flex;
                          flex-direction: column;
                          height: 283px;

                          .cover-upload {
                            height: 114px;
                          }

                          .default-cover-image {
                            display: flex;
                            height: 100%;
                            overflow-y: auto;
                            padding: 15px;
                            flex-wrap: wrap;

                            .cover-image-item {
                              border: 1px solid #f5f5f5;
                              height: 70px;
                              width: 70px;
                              margin-bottom: 8px;
                              margin-right: 8px;

                              img {
                                width: 100%;
                                object-fit: cover;
                                -webkit-transition: 500ms ease-in-out;
                                transition: 500ms ease-in-out;
                                height: 68px;
                                padding: 4px;

                                &:hover {
                                  padding: 8px;
                                  cursor: pointer;
                                  transition: 500ms ease-in-out;
                                }
                              }

                              &.active {
                                border: 1px solid #1890a9 !important;
                              }
                            }
                          }
                        }
                      }
                    }

                    .link {
                      position: absolute;
                      right: -35%;
                      top: 27px;
                      text-decoration: none;

                      @media (min-width: 300px) and (max-width: 630px) {
                        position: relative;
                        right: 0px;
                        top: -17px;
                      }

                      span {
                        font-family: "Nunito", sans-serif;
                        font-size: 13px;
                        font-weight: 500;
                        font-stretch: normal;
                        line-height: 2.08;
                        letter-spacing: normal;
                        text-align: left;
                        color: #1890a9 !important;

                        &:hover {
                          text-decoration: underline;
                        }
                      }
                    }

                    span {
                      font-size: 13px;
                      color: #646262;
                      margin-left: 10px;
                    }

                    .grouped,
                    input[type="text"],
                    textarea,
                    select {
                      background: #fff;
                      font-size: 14px;
                      resize: none;
                      display: flex;
                      margin-bottom: 20px;
                      justify-content: space-between;
                      width: 100%;
                      padding: 10px;
                      outline: none;
                      border-radius: 5px;
                      border: 1px solid #ddd;
                      color: #707070;
                      height: 52px;

                      .__date-field {
                        background: #f4f4f4;
                        width: 49%;
                        padding: 5px;
                      }
                    }

                    textarea {
                      resize: none;
                      height: 150px;
                    }
                  }

                  .btns {
                    margin-top: 20px;

                    .__btn {
                      color: #fff;
                      outline: none;
                      border-radius: 5px;
                      padding: 7px;
                      width: 100px;
                      background-image: linear-gradient(267deg,
                          #1885ad 103%,
                          #04a5a5 0%);
                    }

                    .__cancel {
                      color: #1ba5a4;
                      outline: none;
                      padding: 7px;
                      width: 100px;
                    }
                  }
                }

                .delete-btn {
                  padding: 7px;
                  width: 100px;
                  margin-top: 10px;
                  color: #fff;
                  border-radius: 5px;
                  background-color: #707070;
                }

                .setting-card {
                  background-color: #fff;
                  border-radius: 5px;
                  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.16);
                  padding: 20px;
                  margin-bottom: 10px;

                  .switch-account-options {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 10px;

                    .switch-btn {
                      display: flex;
                      align-items: center;
                      gap: 10px;
                      background: #fff;
                      border-radius: 5px;
                      padding: 10px;
                      border: 1px solid #e0e0e0;
                      cursor: pointer;
                      transition: all 0.2s ease;

                      &:hover {
                        background: #f5f5f5;
                        border-color: #1ba5a4;
                      }

                      span {
                        color: #333;
                        font-size: 14px;
                        font-weight: 500;
                      }

                      img {
                        opacity: 0.8;
                      }
                    }
                  }
                }



              }
            }
          }
        }
      }
    }

    .__menus {
      display: none;

      @media (min-width: 300px) and (max-width: 630px) {
        display: grid;
        width: 100%;
        background: #f5f9fc !important;
        position: fixed;
        bottom: 0;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 1px;
      }

      span {
        padding: 10px;
        text-align: center;
        color: #1885ad;
      }

      .__activee {
        background: #1885ad;
        color: #fff;
      }
    }
  }
}

.floater {
  position: fixed;
  bottom: 0px;
  right: 10px;
}

.__label {
  font-size: 16px !important;
  color: #000 !important;
}

.__hide {
  display: none;
}

.__white {
  color: #fff;
  width: 100%;
  text-align: center;
}

.texte {
  display: flex;
  width: 100%;
  margin-left: 20px;
  margin-top: 40px;
  flex-direction: column;

  span {
    color: #707070;
    font-size: 14px;
  }
}

.wide {
  width: 50%;
}

.__layout {
  display: flex;
  flex-direction: column;
  color: #fff;
  font-weight: normal;
  margin-bottom: 20px;

  .div {
    display: flex;
    flex-direction: column;
    color: #fff;

    input,
    textarea {
      background: #fff;
      color: #848484;
      font-size: 12px;
      padding: 5px 10px;
      border-radius: 5px;
      outline: none;
    }
  }

  .btns-2 {
    margin-top: 20px;

    .cancel {
      color: #fff !important;
    }
  }
}

.__show {
  display: unset;
}

.__colored {
  color: #1890a9 !important;
}

.__m10 {
  margin-top: 10px;
}

.__m20 {
  margin-top: 20px;
}

.__green {
  color: #1ba5a4 !important;
}

.__dark {
  font-weight: normal !important;
  font-size: 24px;
  color: #1ba5a4;
}

.__white {
  color: #ffffff;
}

.__v-space {
  margin-top: 15px !important;
}

.__card {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.16);
}

.__box {
  margin-top: 10px;
  font-weight: normal;
  border-radius: 7px;
}

.active_link {
  color: #1890a9;
  font-weight: normal;
  box-sizing: border-box !important;
  padding-bottom: 3px;
  border-bottom: 4px solid #1890a9;
}

.__inpt-edit {
  width: 100%;
  color: gray;
  height: 30px;
  outline: none;
  font-size: 11px;
  background: #e9ebed;
  border-radius: 3px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.16);
  padding: 2px 10px;
}

.__grid__row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
}

.__grid__row {
  display: flex;
}

.__grid__row-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
}

.__textview {
  width: 100%;
  color: #000000;
  outline: none;
  font-size: 14px;
  font-weight: normal;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  padding: 7px 30px 7px 10px;
}

.input-group {
  position: relative;
  display: flex;
  flex-direction: row;

  textarea {
    resize: none;
    height: 120px;
  }

  .__textview {
    width: 100%;
    color: #000000;
    outline: none;
    font-size: 14px;
    font-weight: normal;
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    padding: 10px 30px 10px 10px !important;
  }

  .__textview-layout {
    width: 100%;
    color: #000000;
    display: flex;
    outline: none;
    font-size: 12px;
    font-weight: normal;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
    background: #ffffff;
    border-radius: 5px;
    padding: 10px 30px 10px 10px !important;
  }

  img {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
}

.addon {
  display: flex;
  flex-direction: row;
  position: relative;

  button {
    background: #1ba5a4;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    color: #fff;
    width: 78px;
    outline: none;
    height: 41px;
  }

  input {
    flex-grow: 1;
    color: #707070;
    outline: none;
    font-size: 14px;
    font-weight: normal;
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    padding: 10px 30px 10px 10px !important;
  }

  .result-search {
    position: absolute;
    background: #fff;
    border-radius: 5px;
    top: 42px;
    z-index: 999;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
    padding: 10px 10px 0 10px;

    .person-item {
      display: flex;
      cursor: pointer;
      padding: 5px;
      border-bottom: 1px solid #d8d8d8;

      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        border-radius: 100%;
      }

      span {
        margin-top: 5px;
        font-size: 13px;
      }
    }
  }
}

.item-grp {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background: rgba(244, 244, 244, 0.1);
  position: relative;

  .skill-input {
    width: 100%;
    color: #6e6e6e;
    outline: none;
    font-size: 12px;
    font-weight: normal;
    border-radius: 3px;
    padding: 3px 30px 3px 10px;
  }

  .close-btn {
    background: #646262;
    padding: 3px;
    border-radius: 100%;
    width: 15px;
    height: 15px;
    position: absolute;
    top: -15px;
    left: 0;
    cursor: pointer;
  }

  .save-btn {
    position: absolute;
    right: 10px;
    top: -15px;
    width: 15px;
    height: 15px;
  }
}

.__pname {
  margin-top: 22px;
}

.__row-inputs {
  display: grid;
  grid-column-gap: 10px;
  grid-template-columns: 1fr 1fr;
}

.input__dropdown {
  position: relative;
  padding: 0;
  margin-bottom: 10px;
  width: 100%;

  .dropdown__wrapper {
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 999;
    top: 0;

    .input {
      position: relative;

      input {
        z-index: 992;
        width: 100%;
        padding-right: 45px;
      }

      .btn-right {
        position: absolute;
        right: 20px;
        cursor: pointer;
        top: 6px;
        font-size: 6pt;
      }
    }
  }
}

* {
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  /* scrollbar itself */
  &::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
    border: 4px solid #f2f2f2;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }
}

.__edit {
  img {
    width: 13px;
    margin-top: 3px;
  }
}

.__btns {
  display: flex;
  width: 40%;
  padding-left: 10px;
  margin-top: 10px;
  justify-content: space-between;

  .cancel {
    color: #1ba5a4;
    cursor: pointer;
    font-weight: normal;
    height: 30px;
    padding: 3px 20px;
    font-size: 14px;
  }

  .save {
    background: #1ba5a4;
    color: #fff;
    font-size: 14px;
    font-weight: normal;
    cursor: pointer;
    border-radius: 5px;
    height: 30px;
    padding: 3px 10px;
  }
}

html {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

*,
*:before,
*:after {
  -webkit-box-sizing: inherit;
  -moz-box-sizing: inherit;
  box-sizing: inherit;
}

.__btn {
  background: #1ba5a4;
  color: #fff;
  border-radius: 5px;
  padding: 7px 40px;
}

.__cancel {
  color: #1ba5a4;
  padding: 7px 40px;
}

.card__body {
  padding: 20px;
  z-index: 9999;
  width: 100%;

  .__cont {
    display: flex;
    flex-direction: column;

    .icons {
      display: flex;
      width: 100%;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 0.7px solid #a0a0a0;
      margin-top: 10px;

      div {
        margin-right: 10px;

        label {
          font-size: 12px;
          margin-right: 10px;
        }

        input {
          margin-top: 5px;
        }
      }
    }

    .body {
      padding: 20px;
      border-radius: 5px;
      background: #f4f4f4;
      border: 1px solid #707070;

      .template {
        width: 100%;
        background: #fff;
        box-shadow: 0 6px 5px rgba(0, 0, 0, 0.16);
        margin-right: 10px;

        button {
          height: 10px;
          font-size: 4px;
          outline: none;
          color: #fff;
          border: none;
          background: #0e9695;
        }

        .header {
          display: flex;
          width: 100%;

          .first {
            display: flex;
            padding-left: 10px;
            padding-right: 10px;
            flex-direction: column;

            img {
              width: 30px;
              height: 30px;
              border-radius: 100%;
            }

            h2 {
              font-size: 6px;
              margin-top: 10px;
            }
          }

          .second {
            background: #0075a0;
            display: flex;
            flex-grow: 1;
            justify-content: center;
            align-items: center;

            .titles {
              display: flex;
              color: #fff;
              width: 100%;
              justify-content: space-between;
              padding-left: 10px;
              padding-right: 10px;

              h2 {
                font-size: 4px;
              }

              button {
                height: 10px;
                font-size: 4px;
                outline: none;
                border: none;
                background: #0e9695;
              }
            }
          }
        }

        .contents {
          display: flex;
          width: 100%;

          span,
          p,
          button {
            font-size: 4px !important;
          }

          .left {
            width: 100px;
          }

          .right {
            flex-grow: 1;
          }
        }
      }
    }

    .actiond {
      margin-top: 10px;
      display: flex;

      button {
        background: #1890a9;
        color: #fff;
        border-radius: 5px;
        padding: 5px 10px;
        justify-content: space-between;
        align-items: center;
        outline: none;
      }

      .cancel {
        background: transparent;
        color: #0590ab;
      }
    }
  }

  .__input {
    margin: 20px 0;
    width: 100%;

    span {
      color: #979797;
      font-size: 14px;
      font-weight: normal;
    }

    input {
      width: 100%;
      color: gray;
      font-size: 14px;
      height: 30px;
      outline: none;
      background: #e9ebed;
      border-radius: 3px;
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.16);
      padding: 2px 10px;
    }
  }

  .btns {
    display: flex;
    width: 50%;
    float: right;
    justify-content: space-between;

    .cancel {
      color: #1ba5a4;
      cursor: pointer;
      font-weight: normal;
      height: 22px;
      padding: 1px 20px;
      font-size: 14px;
    }

    .save {
      background: #1ba5a4;
      color: #fff;
      font-size: 14px;
      font-weight: normal;
      cursor: pointer;
      border-radius: 5px;
      height: 22px;
      padding: 1px 10px;
    }
  }

  .btns-2 {
    display: flex;
    float: right;

    .cancel {
      color: #1ba5a4;
      cursor: pointer;
      font-weight: normal;
      height: 22px;
      padding: 1px 20px;
      font-size: 11px;
    }

    .save {
      background: #1ba5a4;
      color: #fff;
      font-size: 11px;
      font-weight: normal;
      cursor: pointer;
      border-radius: 5px;
      height: 22px;
      padding: 1px 10px;
    }
  }

  .__body {
    background: #f0eaea;
    padding: 20px;

    .__rowed {
      display: flex;
      width: 100%;
      margin-bottom: 20px;
      justify-content: space-between;

      span {
        color: #646262;
        font-size: 12px;
      }

      input,
      select {
        background: #ffffff;
        border-radius: 5px;
        padding: 5px 10px;
        outline: none;
        width: 80%;
        font-size: 12px;
        color: #c4c4c4;
      }

      select {
        width: 30%;
      }

      img {
        cursor: pointer;
      }

      .img {
        max-width: 15px;
        max-height: 15px;
      }
    }
  }

  .__rowed {
    position: relative;
  }

  .dropdown__body {
    background: #fff !important;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    position: absolute;
    width: 80%;
    top: 30px;
    z-index: 10;

    .dropdown__item {
      display: flex;
      cursor: pointer;
      padding: 0px 15px 5px 15px;
      margin-top: 10px;
      border-bottom: 1px solid #e6e6e6;
      flex-direction: row;

      img {
        width: 19px;
        border-radius: 100px;
        height: 19px;
        margin-right: 8px;
      }

      .text {
        display: flex;
        color: #808080;
        margin-top: -3px;
        font-size: 8pt;
        flex-direction: column;

        .small {
          font-size: 6pt;
          font-weight: normal;
          margin-top: -2px;
        }
      }
    }
  }
}

.__textview {
  position: relative;
  outline: none;

  input {
    outline: none;
  }
}

.__lined2 {
  display: flex;
  width: 100%;
  justify-content: space-between;

  .invite {
    color: #1887ac;
    font-size: 12px;
    margin-top: 10px;
    cursor: pointer;
  }

  img {
    margin-top: 5px;
    cursor: pointer;
  }
}

.prof {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 100%;
}

.dropdown__body {
  background: #f2f2f2 !important;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
  border-radius: 4px;
  margin-top: -20px;
  padding-top: 25px;
  width: fit-content;
  z-index: 10;

  .dropdown__item {
    display: flex;
    cursor: pointer;
    padding: 0px 15px 5px 15px;
    margin-top: 10px;
    border-bottom: 1px solid #e6e6e6;
    flex-direction: row;

    img {
      width: 19px;
      border-radius: 100px;
      height: 19px;
      margin-right: 8px;
    }

    .text {
      display: flex;
      color: #808080;
      margin-top: -3px;
      font-size: 8pt;
      flex-direction: column;

      .small {
        font-size: 6pt;
        font-weight: normal;
        margin-top: -2px;
      }
    }
  }
}

.delete {
  cursor: pointer;
  color: #c64a4a !important;
  font-weight: normal !important;
  margin-top: -10px;
}

.greyed {
  background: #f8f8f8;
}

.box {
  background: #fff;
  border-radius: 5px;
  padding-bottom: 20px;
  margin-bottom: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
}

.lesss,
.less {
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 5px !important;
}

.skills-inner-tab {
  .inner-links {
    border-radius: 5px;
    background: #fff;
    display: flex;
    overflow: hidden;
    justify-content: space-between;

    /*box-shadow: 0 1px 3px rgba(0,0,0,0.16);*/
    button {
      font-size: 12px;
      background: #cccccc;
      outline: none;
      border: none;
      flex: 1;
      padding: 10px;
      color: #ffffff;
    }

    .button__active {
      background: #fff !important;
      color: #1ba5a4;
    }
  }

  .inner-body {
    padding-bottom: 20px;

    .adding-form {
      margin-top: 10px;
      padding: 10px;
      background: #fff;
      margin-bottom: 10px;
      display: flex;
      border-radius: 5px;

      .part {
        display: flex;
        flex-grow: 1;
        flex-direction: column;

        input,
        select {
          border: none;
          border-radius: 5px;
          margin-top: 10px;
          box-shadow: none !important;
          margin-bottom: 10px;
          padding: 7px 10px;
          font-weight: normal;
          outline: none;
          background: #f4f4f4 !important;
        }
      }
    }
  }

  .list-items {
    display: block;
    margin-top: 10px;

    .____item {
      padding: 2px 10px;
      background: #999999;
      margin-right: 10px;
      position: relative;
      border-radius: 16px;
      display: inline-block;

      span {
        color: #fff;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 80px;
        margin-right: 10px;
      }

      .close {
        position: absolute;
        right: -5px;
        top: -10px;
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
    }
  }
}

.__member-container {
  .__member-container-wrapper {
    padding: 2px 5px;
    background: #999999;
    margin-right: 10px;
    position: relative;
    border-radius: 16px;
    display: flex;

    span {
      color: #fff;
      margin-right: 10px;
    }

    img {
      border-radius: 100%;
      width: 22px;
      height: 22px;
    }

    .close {
      position: absolute;
      right: -5px;
      top: -10px;
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
  }
}

.expendable {
  width: 15px;
  cursor: pointer;
  margin-left: 10px;
}

.__actionsss {
  margin-top: 10px;

  button {
    width: 100px;
    outline: none;
    border: none;
    border-radius: 5px;
    padding: 5px;
  }

  .done {
    background: #1885ad;
    color: #fff;
  }

  .cancel {
    background: transparent;
    color: #1885ad;
    margin-left: 10px;
  }
}

.__bg-grey {
  background: #f5f5f5 !important;
  border-radius: 10px;
  padding: 20px;
}

.__padded {
  padding: 20px;
}

.b__20 {
  margin-bottom: 20px;
}

.cardd__boddy {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  justify-content: center;

  .__header {
    margin-top: 20px;

    label {
      font-family: "Nunito", sans-serif;
      font-size: 16px;
      font-weight: 700;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.35;
      letter-spacing: 0.01px;
      text-align: center;
      color: #808080;
    }
  }

  .contents {
    align-self: center;
    display: flex;
    margin-top: 20px;
    font-size: 14px;
    flex-direction: column;
    justify-content: center;

    p {
      font-family: "Nunito", sans-serif;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.31;
      letter-spacing: 0px;
      text-align: center;
      color: #808080;
    }
  }

  .footer {
    margin-bottom: 20px;
    margin-top: 10px;

    button {
      width: 80px;
      height: 20px;
      color: #fff;
      cursor: pointer;
      outline: none;
      border: none;
      font-size: 12px;
      margin: 0 10px;
      border-radius: 5px;
      background-color: #620000;
    }

    .cancel {
      background: transparent;
      color: #6e6e6e;
    }

    .ok-info {
      background: #1890a9;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.__grid__row {
  display: flex;
}

body,
html {
  background: #fff;
}

.vdp-datepicker__calendar {
  z-index: 999999999 !important;
}

.__underlined {
  cursor: pointer;
  text-decoration: underline;
}

input.datepicker {
  outline: none;
  z-index: 99999;

  &:focus {
    outline: none;
  }

  &:hover {
    outline: none;
  }
}

.vdp-datepicker * {
  outline: none;
  z-index: 99999;

  &:hover {
    outline: none;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}

.input {
  z-index: 99999;
}

.circled-avatar {
  width: 30px;
  margin-top: 5px !important;
  height: 30px;
  border-radius: 100%;
}

.bullets {
  display: flex;
  margin-top: 5px;

  .bullet {
    margin-left: 5px;
    width: 10px;
    height: 10px;
    background: transparent;
    border: 1px solid #1ba5a4;
    border-radius: 100%;
  }

  .filled {
    background: #1ba5a4;
  }
}

.range-date {
  display: grid;
  grid-column-gap: 5px;
  grid-template-columns: auto auto;
  height: 45px;
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 4px 0px;
  padding-right: 10px;
  position: relative;

  .date-field {
    background: #efefef;
    margin-left: 5px;
    height: 36px;
    border-radius: 5px;
    padding: 8px 10px;
    width: 100%;

    .date-field-input {
      width: 100% !important;
    }
  }

  .check-label {
    position: absolute;
    z-index: 999;
    top: -19px;
    right: 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    label {
      width: calc(100% - 10px);
      text-align: right;
    }

    input {
      width: 10px;
      margin-left: 5px;
    }
  }
}
</style>